import { Injectable, inject } from '@angular/core';
import { productFruits } from 'product-fruits';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from '../../../environments/environment';
import { ProductFruitsService } from './product-fruits.service';

@Injectable({
  providedIn: 'root',
})
export class ProductFruitsIntegrationService {
  private readonly productFruitsService = inject(ProductFruitsService);
  private readonly translocoService = inject(TranslocoService);

  private oid: string | null = null;
  private renewalTimeoutId: ReturnType<typeof setTimeout> | undefined;

  load(oid: string | null): void {
    this.oid = oid;

    if (window.productFruits) {
      (
        window.productFruits as unknown as { services: { destroy: () => void } }
      ).services.destroy();
    }

    const lang = this.translocoService.getActiveLang();
    this.productFruitsService.getHmac().subscribe(({ hash, expiration }) => {
      productFruits.init(environment.productFruits.workspaceId, lang, {
        username: oid ?? '',
        hmac: { hash, expiration },
      });
      this.clearScheduledRenewal();
      this.scheduleRenewal(expiration);
    });
  }

  private renewLogin(): void {
    this.productFruitsService.getHmac().subscribe(({ hash, expiration }) => {
      if (typeof window.productFruits?.identifyUser === 'function') {
        window.productFruits.identifyUser({
          username: this.oid ?? '',
          hmac: { hash, expiration },
        });
        this.scheduleRenewal(expiration);
      } else {
        console.error('productfruits is not initialized');
      }
    });
  }

  private scheduleRenewal(expiration: string): void {
    const delay = new Date(expiration).getTime() - Date.now();
    this.renewalTimeoutId = setTimeout(
      () => {
        this.renewLogin();
      },
      Math.max(delay, 0),
    );
  }

  private clearScheduledRenewal(): void {
    if (this.renewalTimeoutId) {
      clearTimeout(this.renewalTimeoutId);
      this.renewalTimeoutId = undefined;
    }
  }
}
